import React from 'react'
import { motion } from 'framer-motion'
import './ContactUs.css'
import { FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const ContactUs = () => {
    return (
        <section className='contact-section' id='contact-us'>
            <div className='contact-inner'>
                <motion.div
                    className='contact-left'
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <p className='contact-eyebrow'>Get in touch</p>
                    <h2 className='contact-headline'>
                        Let's build<br />something<br />together.
                    </h2>
                </motion.div>

                <motion.div
                    className='contact-right'
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                >
                    <div className='contact-block'>
                        <p className='contact-label'>Address</p>
                        <p className='contact-value'>
                            MindForm Architects and Interior Designers<br />
                            E022, Embassy Residency<br />
                            Cheran Nagar, Perumbakkam<br />
                            Chennai – 600100
                        </p>
                    </div>

                    <div className='contact-block'>
                        <p className='contact-label'>Phone</p>
                        <p className='contact-value'>+91 89399 58099</p>
                    </div>

                    <div className='contact-block'>
                        <p className='contact-label'>Email</p>
                        <a
                            href="mailto:mindformarchitects@gmail.com"
                            className='social-link'
                        >
                            <MdEmail size={22} />
                            <span>mindformarchitects@gmail.com</span>
                        </a>
                    </div>

                    <div className='contact-block'>
                        <p className='contact-label'>Follow</p>
                        <div className='contact-social'>
                            <a
                                href="https://www.instagram.com/mindformarchitects/"
                                target="_blank"
                                rel="noreferrer"
                                className='social-link'
                            >
                                <FaInstagram size={22} />
                                <span>Instagram</span>
                            </a>
                            <a
                                href="https://www.facebook.com/mindform.architects.and.interior.designers"
                                target="_blank"
                                rel="noreferrer"
                                className='social-link'
                            >
                                <FaFacebook size={22} />
                                <span>Facebook</span>
                            </a>
                            <a
                                href="https://www.linkedin.com/in/preme-chidambaram-ba3abb66/"
                                target="_blank"
                                rel="noreferrer"
                                className='social-link'
                            >
                                <FaLinkedin size={22} />
                                <span>LinkedIn</span>
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>

            <div className='contact-footer'>
                <p className='contact-footer-text'>© {new Date().getFullYear()} MindForm Architects and Interior Designers</p>
            </div>
        </section>
    )
}

export default ContactUs
